import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=620a2e75&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"
import style0 from "./ui-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620a2e75')) {
      api.createRecord('620a2e75', component.options)
    } else {
      api.reload('620a2e75', component.options)
    }
    module.hot.accept("./ui-button.vue?vue&type=template&id=620a2e75&", function () {
      api.rerender('620a2e75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/ui-button.vue"
export default component.exports